<div [@triggerName]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</div>

<environment-badge></environment-badge>
<popup [config]="popupConfig"></popup>

<ngx-loading-bar [color]="'#6c757d'" [includeSpinner]="false"></ngx-loading-bar>
